import { defRoute, LoadedProps } from '@components/router';
import { RuzcalMgmtPage } from '../mgmt-page';
import { ListAddAction, PageContent, PageSection, PageHeading } from '../common';
import { rpx } from 'client/lib/rpx-client';
import { IcoCalendar, IcoUser } from '@components/icons';
import dayjs from 'dayjs';

export const route = defRoute({ authLevel: 'guide', load, Page });

async function load() {
  const forms = await rpx.ruzcalForms.getForms();
  return { forms };
}

function Page(props: LoadedProps<typeof load>) {
  const { forms } = props.state;
  return (
    <RuzcalMgmtPage title="Calendar Forms" currentPage="forms">
      <PageContent>
        <PageSection>
          <PageHeading
            title="Calendar Forms"
            subtitle="Manage session or other intake forms."
            action={<ListAddAction href="/calendar/forms/new" content="Add new form" />}
          />
          {forms.map((f) => (
            <span class="border rounded-2xl overflow-hidden" key={f.id}>
              <a
                href={`/calendar/forms/${f.id}`}
                class="flex flex-col p-4 gap-1 hover:bg-gray-100 transition-all text-inherit relative"
              >
                <span class="font-semibold text-base">{f.name}</span>

                <footer class="grid grid-cols-2 gap-2 sm:flex sm:gap-8 items-center">
                  <span class="inline-flex items-center gap-2">
                    <IcoUser /> {f.userCount} reponses
                  </span>
                  {f.submittedAt && (
                    <span class="inline-flex items-center gap-2">
                      <IcoCalendar /> {dayjs(f.submittedAt).format('YYYY, MMM DD')}
                    </span>
                  )}
                </footer>
              </a>
            </span>
          ))}
        </PageSection>
      </PageContent>
    </RuzcalMgmtPage>
  );
}
